import * as yup from "yup";

export const StockValidationSchema = yup.object().shape({
    stock_quantity: yup.number().required("Stock Quantity is Required"),
    sell_quantity: yup.number().required("Sell Quantity is Required"),
    rate: yup.number().required("Rate is Required"),
});
